import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import LabeledCheckbox from './LabeledCheckbox';
import { styles } from '../../styles/form-styles';

function CheckboxGroup(props) {
  const { classes } = props;
  let checkboxesGroup1 = [];
  let checkboxesGroup2 = [];
  props.checkboxes.forEach((checkbox, index) => {
    const { checked, friendlyName, id, onChange } = checkbox;
    if(index < props.checkboxes.length / 2) {
      checkboxesGroup1.push(
        <LabeledCheckbox
          checked={checked}
          label={friendlyName}
          value={id}
          onChange={props.toggleChecked}
          key={index}
          index={index}
        />);
    } else {
      checkboxesGroup2.push(<LabeledCheckbox
                  checked={checked}
                  label={friendlyName}
                  value={id}
                  onChange={props.toggleChecked}
                  key={index}
                  index={index}
                />);
    }
  })

  return (
      <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">{props.label}</FormLabel>
          <div className={classes.checkboxGroup}>
          <FormGroup>
          {checkboxesGroup1}
          </FormGroup>
          <FormGroup>
          {checkboxesGroup2}
          </FormGroup>
          </div>
      </FormControl>
  )
}

CheckboxGroup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CheckboxGroup);



// WEBPACK FOOTER //
// ./src/components/Settings/CheckboxGroup.js